import styled from "styled-components";

const WholeSaleMarketInfo = styled.div`
  border-top: 1px solid #dfe2e6;
  width: 100%;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    font-size: 0.875rem;
    max-width: 250px;
  }

  p:first-child {
    margin-top: 40px;
  }

  button {
    border-radius: 8px;
    border: 0;
    background-color: #ff7a00;
    color: white;
    font-size: 0.875rem;
    font-weight: bold;
    width: 100%;
    padding: 12px 0;
    max-width: 250px;
    margin: 16px 0 32px 0;
  }
`;

export { WholeSaleMarketInfo };
